__turbopack_context__.v({
  "less": "description-module-scss-module__INRZRa__less",
  "lessPosition": "description-module-scss-module__INRZRa__lessPosition",
  "more": "description-module-scss-module__INRZRa__more",
  "moreBt": "description-module-scss-module__INRZRa__moreBt",
  "morePosition": "description-module-scss-module__INRZRa__morePosition",
  "preMsg": "description-module-scss-module__INRZRa__preMsg",
  "scrRedLess": "description-module-scss-module__INRZRa__scrRedLess",
  "scrRedMore": "description-module-scss-module__INRZRa__scrRedMore",
});
